var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"training-center__banner"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('selectionsBannerLeft'))}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('selectionsBannerRight'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }